<template>
  <div
    class="ModuleStudent"
    id="student"
    style="height: 260px; top: 140px; left: 50px"
  >
    <!----><!----><!----><!----><!---->
    <div class="StuTM2">
      <BasicsWriteFirst></BasicsWriteFirst>
      <div class="middle">
        <div class="PstuWarning m-left" :class="{ 'panes2': acCardPanes < 3 }">
          <div class="w-left">
            <span>注意事项</span>
          </div>
          <!---->
          <div class="ql-toolbar ql-snow">
            <span class="ql-formats"
              ><span class="ql-size ql-picker"
                ><span
                  class="ql-picker-label"
                  tabindex="0"
                  role="button"
                  aria-expanded="false"
                  aria-controls="ql-picker-options-279"
                  ><svg viewBox="0 0 18 18">
                    <polygon
                      class="ql-stroke"
                      points="7 11 9 13 11 11 7 11"
                    ></polygon>
                    <polygon
                      class="ql-stroke"
                      points="7 7 9 5 11 7 7 7"
                    ></polygon></svg></span
                ><span
                  class="ql-picker-options"
                  aria-hidden="true"
                  tabindex="-1"
                  id="ql-picker-options-279"
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="10px"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="12px"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="13px"
                  ></span></span></span
              ><select class="ql-size" style="display: none">
                <option value="10px"></option>
                <option selected="selected"></option>
                <option value="12px"></option>
                <option value="13px"></option></select
              ><span class="ql-font ql-picker"
                ><span
                  class="ql-picker-label"
                  tabindex="0"
                  role="button"
                  aria-expanded="false"
                  aria-controls="ql-picker-options-280"
                  data-value="SimSun"
                  ><svg viewBox="0 0 18 18">
                    <polygon
                      class="ql-stroke"
                      points="7 11 9 13 11 11 7 11"
                    ></polygon>
                    <polygon
                      class="ql-stroke"
                      points="7 7 9 5 11 7 7 7"
                    ></polygon></svg></span
                ><span
                  class="ql-picker-options"
                  aria-hidden="true"
                  tabindex="-1"
                  id="ql-picker-options-280"
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="SimSun"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="KaiTi"
                  ></span></span></span
              ><select class="ql-font" style="display: none">
                <option value="SimSun"></option>
                <option value="KaiTi"></option></select
              ><span class="ql-lineheight ql-picker"
                ><span
                  class="ql-picker-label"
                  tabindex="0"
                  role="button"
                  aria-expanded="false"
                  aria-controls="ql-picker-options-281"
                  data-value=""
                  ><svg viewBox="0 0 18 18">
                    <polygon
                      class="ql-stroke"
                      points="7 11 9 13 11 11 7 11"
                    ></polygon>
                    <polygon
                      class="ql-stroke"
                      points="7 7 9 5 11 7 7 7"
                    ></polygon></svg></span
                ><span
                  class="ql-picker-options"
                  aria-hidden="true"
                  tabindex="-1"
                  id="ql-picker-options-281"
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value=""
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="1"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="1.5"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="1.6"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="1.7"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="1.8"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="1.9"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="2"
                  ></span
                  ><span
                    tabindex="0"
                    role="button"
                    class="ql-picker-item"
                    data-value="2.5"
                  ></span></span></span
              ><select class="ql-lineheight" style="display: none">
                <option value=""></option>
                <option value="1"></option>
                <option value="1.5"></option>
                <option value="1.6"></option>
                <option value="1.7"></option>
                <option value="1.8"></option>
                <option value="1.9"></option>
                <option value="2"></option>
                <option value="2.5"></option></select
              ><button type="button" class="ql-bold">
                <svg viewBox="0 0 18 18">
                  <path
                    class="ql-stroke"
                    d="M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z"
                  ></path>
                  <path
                    class="ql-stroke"
                    d="M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z"
                  ></path>
                </svg></button
              ><button type="button" class="ql-underline">
                <svg viewBox="0 0 18 18">
                  <path
                    class="ql-stroke"
                    d="M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3"
                  ></path>
                  <rect
                    class="ql-fill"
                    height="1"
                    rx="0.5"
                    ry="0.5"
                    width="12"
                    x="3"
                    y="15"
                  ></rect>
                </svg></button
            ></span>
          </div>
          <div class="StudentEditor ql-container ql-snow" style="flex: 1 1 0%">
            <div class="ql-editor" data-gramm="false" contenteditable="true">
              <p>
                <span class="bfont">1</span
                >.答题前请将姓名、班级、考场、座号和准考证号填写清楚。
              </p>
              <p>
                <span class="bfont">2</span
                >.客观题答题,必须使用2B铅笔填涂,修改时用橡皮擦干净。
              </p>
              <p>
                <span class="bfont">3</span>.主观题必须使用黑色签字笔书写。
              </p>
              <p>
                <span class="bfont">4</span
                >.必须在题号对应的答题区域内作答,超出答题区域书写无效。
              </p>
              <p>
                <span class="bfont">5</span>.保持答卷清洁完整。
              </p>
            </div>
            <div class="tianfu-info">
              <div class="example-c">
                正确填涂
                <div class="example-box"></div>
              </div>
              <div class="right1">
              <div class="stop-c">
                缺考标记
                <div class="stop-box c-b"></div>
              </div>
            </div>
          </div>

            <div
              class="ql-clipboard"
              contenteditable="true"
              tabindex="-1"
            ></div>
            <div class="ql-tooltip ql-hidden">
              <a
                class="ql-preview"
                rel="noopener noreferrer"
                target="_blank"
                href="about:blank"
              ></a
              ><input
                type="text"
                data-formula="e=mc^2"
                data-link="https://quilljs.com"
                data-video="Embed URL"
              /><a class="ql-action"></a><a class="ql-remove"></a>
            </div>
          </div>
        </div>
        <!---->
        <div>
          <div class="PstuStickup2">
            <div class="stickarea">
              <div class="lt"></div>
              <div class="lb"></div>
              <div class="rt"></div>
              <div class="rb"></div>
              <div class="info">贴条码区域</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="footer">
        <div class="PstuExample f-left">
          <div class="example1">
            <div class="example-c">
              正确填涂
              <div class="example-box"></div>
            </div>
            <div class="example-c">
              错误填涂
              <img
                class="example-img"
                src="data:image/png;base64,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"
              />
            </div>
          </div>
        </div>
        <div class="PstuStop two_width f-right">
          <div class="container1">
            <div class="left1">
              <div class="t1">考生禁填</div>
              <div class="st1">(由监考老师填涂)</div>
            </div>
            <div class="right1">
              <div class="stop-c">
                缺考
                <div class="stop-box"></div>
              </div>
              <div class="stop-c">
                违规
                <div class="stop-box"></div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!----><!---->
  </div>
</template>
<script>
import BasicsWriteFirst from "./BasicsWriteFirst.vue";
export default {
  props:["acCardPanes"],
  components: { BasicsWriteFirst },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.middle {
  height: 205px;
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 5px;
  .m-left {
    flex: 1;
    margin-right: 5px;
    width: 220px;
    /* height: 100%; */
  }
  .PstuWarning {
    position: relative;
    border: 1px solid var(--card-color, #000);
    
    .w-left {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding-top: 5px;
      padding-bottom: 5px;
      width: 100%;
      background-color: #f8f8f8;
    }
    .ql-toolbar.ql-snow {
      position: absolute;
      top: -42px;
      display: none;
      min-width: 280px;
      width: 100%;
      box-shadow: rgba(0, 0, 0, 0.05) 0 2px 5px 4px !important;
      background-color: #fff;
      .ql-formats {
        margin-right: 15px;
      }
      .ql-lineheight {
        width: 60px;
      }
      .ql-picker {
        color: #4b5563;
        display: inline-block;
        float: left;
        font-size: 14px;
        font-weight: 500;
        height: 24px;
        position: relative;
        vertical-align: middle;
        margin-right: 1px;
        margin-left: 1px;
        .ql-picker-label {
          border: 1px solid transparent;
        }
      }
      .ql-picker-options {
        height: 160px;
        overflow: auto;
      }
      .ql-picker-options {
        border: 1px solid transparent;
        box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
      }
    }
    .ql-container {
      border: none !important;
      font-size: 12px;
      font-family: SimSun;
      height: 100%;
      margin: 0;
      position: relative;
      .ql-editor {
        padding: 0 5px;
        line-height: 1.5;
        overflow: hidden;
        color: var(--card-color, #000);
      }
      .ql-clipboard {
        left: -100000px;
        height: 1px;
        overflow-y: hidden;
        position: absolute;
        top: 50%;
      }
    }
    .ql-tooltip {
      background-color: #fff;
      border: 1px solid #d1d5db;
      box-shadow: 0 0 5px #d1d5db;
      color: #4b5563;
      padding: 5px 12px;
      white-space: nowrap;
      .ql-preview {
        display: inline-block;
        max-width: 200px;
        overflow-x: hidden;
        text-overflow: ellipsis;
        vertical-align: top;
        line-height: 26px;
        cursor: pointer;
        text-decoration: none;
        color: #2563eb;
      }
      &.ql-hidden {
        display: none;
      }
      input {
        display: none;
        border: 1px solid #d1d5db;
        font-size: 13px;
        height: 26px;
        margin: 0;
        padding: 3px 5px;
        width: 170px;
      }
    }
  }
  .PstuStickup2 {
    border: 1px solid var(--card-color, #000);
    height: 203px;
    width: 260px;
    position: relative;
    .stickarea {
      position: absolute;
      width: 240px;
      height: 105px;
      left: 10px;
      top: 50px;
      border-radius: 12px;
      border: 1px dashed #999;

      .lt {
        left: 0;
        top: 0;
        border-right: transparent;
        border-bottom: transparent;
      }
      .lb {
        left: 0;
        bottom: 0;
        border-top: transparent;
        border-right: transparent;
      }
      .rt {
        border-left: transparent;
        border-bottom: transparent;
        right: 0;
        top: 0;
      }
      .rb {
        border-left: transparent;
        border-top: transparent;
        right: 0;
        bottom: 0;
      }
      .info {
        font-size: 22px;
        color: var(--card-color, #000);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
.footer {
  height: 35px;
  display: flex;
  flex-direction: row;
  width: 100%;
  .PstuExample {
    border: 1px solid var(--card-color, #000);
    &.f-left {
      flex: 1;
      margin-right: 5px;
      height: 100%;
    }
    .example1 {
      font-size: 12px;
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: space-around;
      .example-c {
        display: flex;
        align-items: center;
        color: var(--card-color, #000);
        height: 28px;
        .example-box {
          display: inline-block;
          margin-left: 8px;
          width: 20px;
          height: 12px;
          background-color: #444;
        }
        .example-img {
          height: 20px;
          width: 80px;
          margin-left: 10px;
        }
      }
    }
  }
  .f-right {
    flex: 1;
    height: 100%;
    border: 1px solid var(--card-color, #000);
  }
  .two_width {
    width: 340px !important;
  }
  .container1 {
    font-size: 12px;
    display: flex;
    height: 33.5px;
    .left1 {
      width: 95px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      border-right: 1px solid var(--card-color, #000);
      color: var(--card-color, #000);
      .t1 {
        font-weight: 700;
        padding-top: 2px;
      }
      .st1 {
        font-size: 11px;
        color: var(--card-color, #000);
        transform: scale(0.7);
      }
    }
    .right1 {
      flex: 1;
      display: flex;
      flex-direction: row;
      color: var(--card-color, #000);
      align-items: center;
      justify-content: space-around;
      .stop-c {
        display: flex;
        align-items: center;
        .stop-box {
          display: inline-block;
          margin-left: 4px;
          width: 20px;
          height: 12px;
          border: 1px solid var(--card-color, #000);
        }
      }
    }
  }
}
.tianfu-info{
  display: flex;
  justify-content: space-between;
  align-items: center;
  vertical-align: middle;
  border-top: 1px solid #000;
  padding: 5px 10px;
  font-size: 14px;

  .example-box {
      display: inline-block;
      margin-left: 8px;
      width: 20px;
      height: 12px;
      margin-bottom: -2px;
      background-color: #444;
    }
    .stop-box {
      display: inline-block;
      margin-left: 4px;
      width: 20px;
      height: 12px;
      margin-bottom: -2px;
      border: 1px solid var(--card-color, #000);
    }  
}
.panes2{
  .ql-editor{
    padding: 10px 20px;
    line-height: 1.8 !important;
    font-size: 12px;
  }
  .tianfu-info{
    padding: 23px 20px!important;
  }
}
</style>